// extracted by mini-css-extract-plugin
export default {"container":"OrderStatus_container__c1CjK","orderContainer":"OrderStatus_orderContainer__zkfro"};